export default "__VITE_ASSET__970bbc51__"